import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const RecurringRevenueYearToDate = ({ size }) => {
  const { label, value, url, tooltip, change } = useSelector(
    (state) => state.membershipRevenue.membershipDraft.recurring.recurringRevenueYTD
  );
  const currencySymbol = useSelector(
    (state) => state.membershipRevenue.membershipDraft.currencySymbol
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <DataDisplay
      label={label}
      size={size}
      type="money"
      url={url}
      currency={currencySymbol}
      value={value}
      disableAnimation={isUserQa}
      changeProps={{
        changeValue: change,
        toolTip: tooltip || "Percentage change from previous year",
        showBorder: true
      }}
    />
  );
};

export default RecurringRevenueYearToDate;
